export const setToken = (token: string, tokenType: string): void => {
  sessionStorage.setItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`, JSON.stringify({ access_token: token, token_type: tokenType }))
}

export const getToken: any = () => {
  const oidcStorage = JSON.parse(
    sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`),
  )
  if (oidcStorage) {
    return oidcStorage.access_token
  }
  return undefined
}

export default getToken
